var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChipVirtual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 0H10.8751C10.0426 0 9.75006 0.6675 9.75006 1.5L9.75 10.5C9.75 11.3325 10.0425 12 10.875 12H20.25C21.0825 12 21.75 11.3325 21.75 10.5V1.5C21.75 0.6675 21.0825 0 20.25 0ZM20.25 10.5H9.75L9.75001 6H20.25V10.5ZM20.25 3H9.75001L9.75006 1.5H20.25V3Z",
    fill: "#0B7EB5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 10.5,
    width: 3,
    height: 1.5,
    rx: 0.75,
    fill: "#00BFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.25,
    y: 8.25,
    width: 3,
    height: 1.5,
    rx: 0.75,
    fill: "#0B7EB5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 7.5,
    width: 3,
    height: 1.5,
    rx: 0.75,
    fill: "#00BFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 3,
    height: 1.5,
    rx: 0.75,
    fill: "#0B7EB5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 2.25,
    width: 3,
    height: 1.5,
    rx: 0.75,
    fill: "#00BFFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7.5,
    width: 1.5,
    height: 1.5,
    rx: 0.75,
    fill: "#0B7EB5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 4.5,
    width: 1.5,
    height: 1.5,
    rx: 0.75,
    fill: "#0B7EB5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 0.75,
    width: 1.5,
    height: 1.5,
    rx: 0.75,
    fill: "#00BFFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 4.5,
    width: 6,
    height: 1.5,
    rx: 0.75,
    fill: "#0B7EB5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 4.5,
    width: 2.25,
    height: 1.5,
    rx: 0.75,
    fill: "#00BFFF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 3,
    height: 1.5,
    rx: 0.75,
    fill: "#0B7EB5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipVirtual);
export default __webpack_public_path__ + "static/media/chip-virtual.f54c9182e2b2df237ad12ce685939788.svg";
export { ForwardRef as ReactComponent };